import { getOption, setOption } from "../../Utilities/Platform/Options/Options";
import { Bootstrapper } from "../Bootstrapper";
import { generateInstanceID } from "../InstanceIDGenerator";

export class SystemInformationBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        const instanceId = getOption("_instance_id");

        if(instanceId === false) {
            const instanceId = generateInstanceID();

            setOption("_instance_id", instanceId);
            console.log(`The instance ID is currently ${instanceId}`);
        } else {
            console.log(`The instance ID is currently ${instanceId}`);
        }
    }
}
